import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserContactComponent } from './components';

const routes: Routes = [
  {
    path: '',
    component: UserContactComponent,
    data: {
      title: 'Contact Details',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserContactRoutingModule {}
